import { render } from "./EmbedContactsView.vue?vue&type=template&id=3650e863"
import script from "./EmbedContactsView.vue?vue&type=script&lang=js"
export * from "./EmbedContactsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__